
import { Component, Vue, Watch } from 'vue-property-decorator';
import { iPeriodCard, iPointsCard, iLableSetting, ELabeSetting, iCloudRecharge } from '@/interface/purchase';
import {
  getSubcard,
  getCoincard,
  editSubcard,
  editCoincard,
  getLableSetting,
  addLableSetting,
  deleteSubcard,
  releaseSubcard,
  sortSubcard,
  deleteLableSetting,
  getCloudRecharge,
  addCloudRecharge,
  exitCloudRecharge,
  deleteCloudRechage,
} from '@/api/coinManaging';
import CardEdit from './components/card-edit.vue';
import TimeCardsItem from './components/time-cards-item.vue';
import CloudRechageItem from './components/cloud-item.vue';
import CloudRechargeEdit from './components/cloud-edit.vue';
import RechargeItem from './components/recharge-item.vue';
import RechargeItemNew from './components/recharge-item-new.vue';
import RechargeEdit from './components/recharge-edit.vue';
import SpecialGoods from '@/views/coin_manage/price-admin/components/special-goods.vue';
import { toast } from '../../../utils/common';
import { Container, Draggable } from 'vue-smooth-dnd';
import LogUtils from 'panda-log';

@Component({
  components: {
    CardEdit,
    TimeCardsItem,
    RechargeItem,
    RechargeEdit,
    SpecialGoods,
    Container,
    Draggable,
    CloudRechageItem,
    CloudRechargeEdit,
    RechargeItemNew,
  },
})
export default class extends Vue {
  titleVaule: string = '新增';
  checked: boolean = true;
  data: string = '0.9';
  cloudCardList: number = 5;
  dialogVisible: boolean = false;
  dialogVisibleRecharge: boolean = false;
  dialogVisibleCloudRechage: boolean = false;
  fullscreenLoading: boolean = false;
  timeCardsList: iPeriodCard[] = [];
  RechargeCardsList: iPointsCard[] = [];
  cloudRecharge: iCloudRecharge[] = [];
  activeName: string = 'pc';
  // items: any = generateItems(6, (i: Number) => ({ id: i, data: 'Draggable ' + i }));
  client: number = 0;
  editCardsDefault: iPeriodCard = {
    id: 0,
    title: '',
    original_price_desc: '',
    theme: 0,
    price: 0,
    amount: '',
    price_desc: '',
    valid_days: 0,
    is_default: true,
    color: '',
    client: 0,
  };
  editCloudRechargeDefault: iCloudRecharge = {
    id: 0,
    value: null,
    price: null,
    desc: '',
    check: false,
  };
  isSortSetting: boolean = false;
  lableSettingTemp: iLableSetting[] = [
    {
      id: 0,
      idx: ELabeSetting.PRICE_MNANGE,
      cases: ELabeSetting.PRICE_BUY_LABLE,
      text: '',
      version: 0,
      label: '主页“购买”标签:',
      placeholder: '请输入主页“购买”标签',
      maxlength: 5,
    },
    {
      id: 0,
      idx: ELabeSetting.PRICE_MNANGE,
      cases: ELabeSetting.PRICE_WEEK_LABLE,
      text: '',
      version: 0,
      label: '“周期卡”标签',
      placeholder: '请输入“周期卡”标签',
      maxlength: 10,
    },
  ];
  lableSetting: iLableSetting[] = JSON.parse(JSON.stringify(this.lableSettingTemp));

  editCards: iPeriodCard = JSON.parse(JSON.stringify(this.editCardsDefault));
  editCloudRecharge: iCloudRecharge = JSON.parse(JSON.stringify(this.editCloudRechargeDefault));
  editRecharge: iPointsCard = {
    id: 1,
    pos: 1,
    price: 1,
    original_price: 1,
    amount: 1,
    corner_label: '',
    original_price_desc: '',
    is_first_pay: false,
    is_default: false,
    desc1: '',
    desc2: '',
    client: 0,
  };
  editRechargeTwo: iPointsCard = {
    id: 1,
    pos: 1,
    price: 1,
    original_price: 1,
    amount: 1,
    corner_label: '',
    original_price_desc: '',
    is_first_pay: false,
    is_default: false,
    desc1: '',
    desc2: '',
    client: 0,
  };
  handleClick(tab: any) {
    this.client = tab.name == 'ios' ? 5 : 0;
    this.editRecharge.client = this.client;
    this.editRechargeTwo.client = this.client;
    this.getSubcardList(); //卡片设置
    this.getCoincardList(); //充值
    this.getLableList(); //标签设置
    this.getCloudRecharge(); //得到云币充值
  }
  handleClose() {
    this.dialogVisible = false;
    this.dialogVisibleRecharge = false;
    this.dialogVisibleCloudRechage = false;
  }
  change(info: iPeriodCard) {
    this.fullscreenLoading = true;
    this.timeCardsList.forEach(item => {
      if (item.id === info.id) {
        if (!item.is_default) {
          item.is_default = true;
        }
      } else {
        item.is_default = false;
      }
    });
    this.fullscreenLoading = false;
  }
  timeCardsedit(info: iPeriodCard) {
    Object.assign(this.editCards, info);
    this.editCards.price = this.accDiv(this.editCards.price, 100);
    const amount: number = this.editCards.amount;
    this.editCards.amount = amount == -1 ? '' : amount + '';
    this.dialogVisible = true;
    this.titleVaule = '编辑';
  }
  timeCardsAdd() {
    //   console.log(this.editCardsDefault);
    this.titleVaule = '新增';
    Object.assign(this.editCards, this.editCardsDefault);
    this.dialogVisible = true;
  }
  cloudRechargeAdd() {
    this.titleVaule = '新增云朵商品';
    Object.assign(this.editCloudRecharge, this.editCloudRechargeDefault);
    console.log(this.editCloudRecharge, '232');

    this.dialogVisibleCloudRechage = true;
  }
  editSure(info: iPeriodCard) {
    this.fullscreenLoading = true;
    let data = Object.assign({}, info);
    data.color = JSON.stringify(data.color);
    data.price = this.accMul(data.price, 100);
    // const amount: any = data.amount;
    // data.amount = amount == '' ? -1 : this.accMul(data.amount, 60);
    data.amount = parseInt(data.amount);
    data.client = this.client;
    this.saveSubcard(data);
  }
  async editSureCloud(info: iCloudRecharge) {
    try {
      this.fullscreenLoading = true;
      let res = null;
      if (info.id > 0) {
        res = await exitCloudRecharge(info);
      } else {
        res = await addCloudRecharge(info);
      }
      if (res && res.code == 0) {
        this.getCloudRecharge();
        this.dialogVisibleCloudRechage = false;
        toast(info.id > 0 ? '修改成功！' : '添加成功！');
      } else {
        toast(res.msg, 'error');
      }
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.fullscreenLoading = false;
    }
  }
  /*删除云朵充值 */
  async deleteCloudRecharge(info: iCloudRecharge) {
    this.$msgbox({
      title: '提示',
      message: '是否确认删除，删除后，需要发布才能生效!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          this.fullscreenLoading = true;
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          const res: any = await deleteCloudRechage(info.id);
          if (res && res.code == 0) {
            this.getCloudRecharge();
          } else {
            toast(res.msg, 'error');
          }
          done();
          this.fullscreenLoading = false;
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          //    alert(action);
          done();
          instance.confirmButtonLoading = false;
          this.fullscreenLoading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.fullscreenLoading = false;
      });
  }
  check(info: iPointsCard) {
    this.fullscreenLoading = true;
    this.RechargeCardsList.forEach(item => {
      if (item.id === info.id) {
        item.is_default = true;
      } else if (item.is_default) {
        item.is_default = false;
      }
    });
    this.fullscreenLoading = false;
  }
  rechargeEdit(info: iPointsCard) {
    Object.assign(this.editRecharge, info);
    this.editRecharge.price = this.accDiv(this.editRecharge.price, 100);
    this.editRecharge.original_price = this.accDiv(this.editRecharge.original_price, 100);
    this.dialogVisibleRecharge = true;
  }
  CloudRechargeEdit(info: iCloudRecharge) {
    this.titleVaule = '编辑云朵商品';
    const item: any = JSON.parse(JSON.stringify(info));
    item.price = Number((item.price / 100).toFixed(2));
    Object.assign(this.editCloudRecharge, item);
    this.dialogVisibleCloudRechage = true;
  }

  // 除法
  accDiv(arg1: any, arg2: any) {
    var t1 = 0,
      t2 = 0,
      r1,
      r2;
    try {
      t1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      //
    }
    try {
      t2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      //
    }
    r1 = Number(arg1.toString().replace('.', ''));
    r2 = Number(arg2.toString().replace('.', ''));
    return (r1 / r2) * Math.pow(10, t2 - t1);
  }
  // 乘法
  accMul(arg1: any, arg2: any) {
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();

    try {
      m += s1.split('.')[1].length;
    } catch (e) {
      //
    }

    try {
      m += s2.split('.')[1].length;
    } catch (e) {
      //
    }

    return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
  }
  // 保存
  editSureRecharge(info: iPointsCard, infoTwo: iPointsCard) {
    this.fullscreenLoading = true;
    let price: number = 0;
    if (info.is_first_pay == true && info.pos == 0) {
      let data = Object.assign({}, infoTwo);
      data.price = this.accMul(data.price, 100);
      data.original_price = this.accMul(data.original_price, 100);
      this.saveCoincard(data, true);
    }
    info.price = this.accMul(info.price, 100);
    info.original_price = this.accMul(info.original_price, 100);
    this.saveCoincard(info);
  }

  // 月卡/周卡
  async getSubcardList() {
    try {
      const res = await getSubcard({ client: this.client });
      if (res && res.code == 0) {
        let list: any = res.data;
        list.forEach((column: any) => {
          if (!column.color) {
            column.color = { id: 1, colorS: '#8100ff', colorE: '#8969ff' };
          } else {
            column.color = JSON.parse(column.color);
          }
        });
        // this.timeCardsList = Object.assign({}, this.timeCardsList, list);
        this.timeCardsList = list;
        //   console.log(this.timeCardsList);
      }
    } catch (error) {
      LogUtils.debug(error);
    }
  }
  /* 云朵充值 */
  async getCloudRecharge() {
    try {
      let res = await getCloudRecharge({ client: this.client });
      if (res && res.code == 0) {
        this.cloudRecharge = res.data;
      }
    } catch (err) {
      LogUtils.debug(err);
    }
  }
  // 充值列表
  async getCoincardList() {
    try {
      const res = await getCoincard({ client: this.client });
      if (res && res.code == 0) {
        let arr: iPointsCard[] = [];
        for (let item of res.data) {
          if (!(item.pos == 0 && item.is_first_pay == false)) {
            arr.push(item);
          } else {
            this.editRechargeTwo = item;
            this.editRechargeTwo.price = this.accDiv(this.editRechargeTwo.price, 100);
            this.editRechargeTwo.original_price = this.accDiv(this.editRechargeTwo.original_price, 100);
          }
        }
        this.RechargeCardsList = arr;
      }
    } catch (error) {
      LogUtils.debug(error);
    }
  }
  /* 标签查询 */
  async getLableList() {
    let data: any = {};
    try {
      const res = await getLableSetting(ELabeSetting.PRICE_MNANGE);
      if (res && res.code == 0) {
        this.lableSetting = JSON.parse(JSON.stringify(this.lableSettingTemp));
        res.data.tags.forEach((item: any) => {
          if (item.cases == ELabeSetting.PRICE_BUY_LABLE) {
            this.lableSetting.forEach((i: any) => {
              if (i.cases == ELabeSetting.PRICE_BUY_LABLE) {
                i.text = item.text;
                i.version = item.version;
                i.id = item.id;
              }
            });
          } else if (item.cases == ELabeSetting.PRICE_WEEK_LABLE) {
            this.lableSetting.forEach((i: any) => {
              if (i.cases == ELabeSetting.PRICE_WEEK_LABLE) {
                i.text = item.text;
                i.version = item.version;
                i.id = item.id;
              }
            });
          }
        });
      }
    } catch (error) {
      LogUtils.debug(error);
    }
    return data;
  }
  async saveSubcard(info: iPeriodCard) {
    try {
      let res = await editSubcard(info);
      if (res && res.code == 0) {
        this.getSubcardList();
        this.dialogVisible = false;
      } else {
        toast(res.msg, 'error');
      }
      this.fullscreenLoading = false;
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.fullscreenLoading = false;
    }
  }

  /* 发布*/
  async timeCardRelease() {
    /* 验证是否是最后一条数据不允许删除 */

    this.$msgbox({
      title: '提示',
      message: '确认发布吗？发布后立即生效!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          this.fullscreenLoading = true;
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          const res = await releaseSubcard({ client: this.client });
          if (res && res.code == 0) {
            toast('发布成功!', 'success');
            this.getSubcardList();
          } else {
            toast(res.msg, 'error');
          }
          done();
          instance.confirmButtonLoading = false;
          this.fullscreenLoading = false;
        } else if (action === 'cancel') {
          //    alert(action);
          done();
          this.fullscreenLoading = false;
          instance.confirmButtonLoading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.fullscreenLoading = false;
      });
  }
  /* 删除周期*/
  async deleteSubcard(info: iPeriodCard) {
    /* 验证是否是最后一条数据不允许删除 */

    if (this.timeCardsList.length <= 1) {
      toast('为确保正常显示，请保留一条数据');
      return;
    }
    this.$msgbox({
      title: '提示',
      message: '是否确认删除，删除后，需要发布才能生效!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          this.fullscreenLoading = true;
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          const res: any = await deleteSubcard(info.id);
          if (res && res.code == 0) {
            this.getSubcardList();
          } else {
            toast(res.msg, 'error');
          }
          done();
          this.fullscreenLoading = false;
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          //    alert(action);
          done();
          instance.confirmButtonLoading = false;
          this.fullscreenLoading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.fullscreenLoading = false;
      });
  }
  async saveCoincard(info: iPointsCard, bool?: boolean) {
    try {
      const res = await editCoincard(info);
      if (res && res.code == 0) {
        if (!bool) {
          this.getCoincardList();
          this.dialogVisibleRecharge = false;
        }
      } else {
        toast(res.msg, 'error');
      }
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.fullscreenLoading = false;
    }
  }

  async onDrop(dropResult: any) {
    try {
      // console.log('isSortSetting', this.isSortSetting);

      if (!this.isSortSetting) {
        const { removedIndex, addedIndex } = dropResult;
        const self_id: number = this.getSubcardId(removedIndex);
        const other_id: number = this.getSubcardId(addedIndex);
        const info: any = { self_id, other_id };
        this.SortSub(info);
      } else {
        toast('请操作不要太频繁！', 'error');
      }
      // eslint-disable-next-line no-empty
    } catch (e) {
      // console.log(e);
    }
    //this.items = applyDrag(this.items, dropResult);
    //  this.timeCardsList = applyDrag(this.timeCardsList, dropResult);
  }
  async SortSub(info: any) {
    try {
      this.fullscreenLoading = true;
      this.isSortSetting = true;
      let res = await sortSubcard(info);
      if (res && res.code == 0) {
        this.getSubcardList();
      } else {
        toast(res.msg, 'error');
      }
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.fullscreenLoading = false;
      this.isSortSetting = false;
    }
  }
  getSubcardId(index: number) {
    return this.timeCardsList[index].id;
  }

  async handleResetSetting(info: iLableSetting) {
    if (info.text == '') {
      toast('没有配置该标签无需重置', 'error');
      return;
    } else {
      const date: any = { id: info.id, version: info.version };
      try {
        let res = await deleteLableSetting(date);
        if (res && res.code == 0) {
          toast('设置成功！');
          this.getLableList();
        } else {
          toast(res.msg, 'error');
        }
      } catch (error) {
        LogUtils.debug(error);
      } finally {
        this.fullscreenLoading = false;
      }
    }
  }
  /* 标签设置 */
  handleSetting(info: iLableSetting) {
    if (!info.text) {
      toast(info.placeholder, 'error');
      return;
    } else {
      const date: any = { idx: info.idx, cases: info.cases, text: info.text, version: info.version, client: this.client };
      this.AddLableSetting(date);
    }
  }
  async AddLableSetting(data: any) {
    try {
      let res = await addLableSetting(data);
      if (res && res.code == 0) {
        toast('设置成功！');
        this.getLableList();
      } else {
        toast(res.msg, 'error');
      }
      this.fullscreenLoading = false;
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.fullscreenLoading = false;
    }
  }

  @Watch('timeCardsList')
  private getTimeCardsList(newValue: iPeriodCard[], oldValue: iPeriodCard[]) {
    if (newValue.length > 0 && oldValue.length > 0) {
      this.timeCardsList = Object.assign({}, this.timeCardsList, newValue);
    }
  }
  handleSuccessSaveIOSId(type: number) {
    if (type == 1) {
      this.getCoincardList();
    } else {
      this.getSubcardList();
    }
  }
  mounted() {
    this.getSubcardList(); //卡片设置
    this.getCoincardList(); //充值
    this.getLableList(); //标签设置
    this.getCloudRecharge(); //云朵充值
  }
}
